import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[rdSrcFallback]',
  standalone: false,
})
export class ImageFallbackDirective {
  @Input() @HostBinding('src') src: string;
  @Input() rdSrcFallback: string;

  @HostListener('error')
  onError(): void {
    this.src = this.rdSrcFallback;
  }
}
